// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ProjectLineItemGanttChart } from '@/project/components/project-line-item-gantt-chart';
import { GanttItem } from '@/project/components/project-line-item-gantt-types';
import { Box } from '@mui/material';

interface Props {
  items: GanttItem[];
  groupColor: string;
  onClose: () => void;
}

/**
 * Inline Gantt timeline visualization for a single aggregation group.
 * Renders a visx-based chart with one bar per line item. The close
 * button is rendered inside the chart's top axis bar.
 */
export function ProjectLineItemGantt(props: Props) {
  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 2,
        pt: 1,
      }}
    >
      <ProjectLineItemGanttChart
        items={props.items}
        groupColor={props.groupColor}
        onClose={props.onClose}
      />
    </Box>
  );
}
